var map = {
	"./r_book.png": "0de1",
	"./r_figure_01.png": "b31a",
	"./r_figure_02.png": "eeda",
	"./r_figure_03.png": "b816",
	"./r_figure_04.png": "c622",
	"./r_figure_05.png": "f9bb",
	"./r_figure_06.png": "0cd1",
	"./r_movie.png": "9c01"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "083c";